import type { IOrderDetail } from '@/app/[locale]/promotion/types/schema'
import { env } from '@/constants/configs'

export async function fetchCommon(locale: string = 'en') {
  const response = await fetch(`${env.APP_BASE_URL}/api-v2/common/?locale=${locale}`)
  const data = await response.json()

  return data
}

export async function fetchPromotionDetail(
  locale: string = 'en',
  slug: string
): Promise<IPromotion[]> {
  const response = await fetch(
    `${env.APP_BASE_URL}/api-v2/promotion/?locale=${locale}&slug=${slug}`,
    {
      // Add cache-busting options
      cache: 'no-store',
      next: { revalidate: 0 },
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    }
  )
  const data = await response.json()

  return data
}

export async function fetchOrderDetail(
  locale: string = 'en',
  reference: string,
  session: string,
  refType: number = 2
): Promise<IOrderDetail> {
  const response = await fetch(
    `${env.APP_BASE_URL}/api-v2/order/?locale=${locale}&reference=${reference}&session=${session}&ref_type=${refType}`
  )
  const data = await response.json()

  return data
}

export type IEgiftStatus = {
  status: string
  bpds_id: number
  gift_numbers: string[]
  error_message: string
}

export async function fetchEgiftStatus(ref: string): Promise<IEgiftStatus | null> {
  try {
    const res = await fetch(
      `${env.APP_BASE_URL}/api-v2/egift/status/?ref=${encodeURIComponent(ref)}`,
      { credentials: 'same-origin', cache: 'no-store' }
    )
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}
